module.exports = __webpack_public_path__ + "static/media/edit.3d25ae44.svg";